exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handle-message .el-message-box__header[data-v-3bde5ad4]{background:#eee!important}.handle-message .el-message-box__btns[data-v-3bde5ad4]{text-align:center}.handle-message .el-button--primary[data-v-3bde5ad4]{width:180px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bde5ad4","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/apply-list/handles.vue
// module id = TjJH
// module chunks = 29 43 47 50